import { render, staticRenderFns } from "./AccountOffIcon.vue?vue&type=template&id=77b8b3c8"
import script from "./AccountOffIcon.vue?vue&type=script&lang=js"
export * from "./AccountOffIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports